<template>
  <div class="wrap">
    <img :src="img" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      default:
        "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoshow/banner_5_1.png",
    },
  },
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="scss">
img {
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// myImg.vue?6201210c